import { Edge, Position } from "@xyflow/react";
import { FlowDefinition } from "@/types/domain";
import { FormStatus } from "@/types/form-builder";
import { ApproverType, WorkflowNodeKey } from "@/types/flow";
import { ExpenseForm } from "./mock-form";

const layoutedNodes: FlowDefinition["nodes"] = [
  {
    type: WorkflowNodeKey.Form,
    id: "form-node",
    data: {
      next: "",
      parents: [],
      formName: "",
      form: ExpenseForm,
    },
    position: { x: 0, y: 0 },
    targetPosition: Position.Top,
    sourcePosition: Position.Bottom,
    measured: { width: 280, height: 84 },
  },
  {
    type: WorkflowNodeKey.End,
    id: "end-node",
    position: { x: 0, y: 1178 },
    data: {
      next: "",
      parents: [],
    },
    targetPosition: Position.Top,
    sourcePosition: Position.Bottom,
    measured: { width: 280, height: 56 },
  },
  {
    id: "Approval-1762503660232",
    type: WorkflowNodeKey.Approval,
    position: { x: 0, y: 184 },
    data: {
      next: "",
      parents: [],
      approver: ApproverType.ApplicantReportLine,
      approveMethod: { method: "to_level", approveLevel: 1 },
      advancedSetting: "",
      shouldSkip: true,
    },
    targetPosition: Position.Top,
    sourcePosition: Position.Bottom,
    measured: { width: 280, height: 84 },
  },
  {
    id: "Condition-1762503668062",
    type: WorkflowNodeKey.Condition,
    position: { x: 0, y: 368 },
    data: {
      next: "",
      parents: [],
      conditions: [
        {
          isExpression: false,
          name: "fallback-branch",
          next: "Placeholder-1762503668156",
          branch: undefined,
        },
        {
          isExpression: false,
          name: "Amount < \'100000\'",
          next: "Placeholder-1762503669515",
          branch: { field: "Amount", operator: "<", value: "100000" },
        },
        {
          isExpression: false,
          name: "(Amount >= \'100000\') AND (Amount < \'500000\')",
          next: "Placeholder-1762503670556",
          branch: {
            logic: "AND",
            left: { field: "Amount", operator: ">=", value: "100000" },
            right: { field: "Amount", operator: "<", value: "500000" },
          },
        },
        {
          isExpression: false,
          name: "Amount > \'500000\'",
          next: "Placeholder-1762503671456",
          branch: { field: "Amount", operator: ">", value: "500000" },
        },
      ],
    },
    targetPosition: Position.Top,
    sourcePosition: Position.Bottom,
    measured: { width: 280, height: 84 },
  },
  {
    id: "Placeholder-1762503668156",
    type: WorkflowNodeKey.Approval,
    position: { x: -887.5, y: 552 },
    data: { approver: ApproverType.Applicant, next: "", parents: [] },
    targetPosition: Position.Top,
    sourcePosition: Position.Bottom,
    measured: { width: 280, height: 84 },
  },
  {
    id: "Placeholder-1762503669515",
    type: WorkflowNodeKey.Approval,
    position: { x: -400.5, y: 552 },
    data: {
      next: "",
      parents: [],
      approver: ApproverType.ApplicantReportLine,
      approveMethod: { method: "to_job_grade", jobGrade: 60 },
      advancedSetting: "",
      shouldSkip: true,
    },
    targetPosition: Position.Top,
    sourcePosition: Position.Bottom,
    measured: { width: 280, height: 84 },
  },
  {
    id: "Placeholder-1762503670556",
    type: WorkflowNodeKey.Approval,
    position: { x: 243.5, y: 552 },
    data: {
      next: "",
      parents: [],
      approver: ApproverType.ApplicantReportLine,
      approveMethod: { method: "to_job_grade", jobGrade: 60 },
      advancedSetting: "",
      shouldSkip: true,
    },
    targetPosition: Position.Top,
    sourcePosition: Position.Bottom,
    measured: { width: 280, height: 84 },
  },
  {
    id: "Placeholder-1762503671456",
    type: WorkflowNodeKey.Approval,
    position: { x: 887.5, y: 552 },
    data: {
      next: "",
      parents: [],
      approver: ApproverType.ApplicantReportLine,
      approveMethod: { method: "to_job_grade", jobGrade: 60 },
      advancedSetting: "",
      shouldSkip: true,
    },
    targetPosition: Position.Top,
    sourcePosition: Position.Bottom,
    measured: { width: 280, height: 84 },
  },
  {
    id: "ParallelApproval-1762503685183",
    type: WorkflowNodeKey.ParallelApproval,
    position: { x: 243.5, y: 736 },
    data: {
      next: "",
      parents: [],
      logic: "and",
      selectedApprovalIndex: 1,
      approvals: [
        {
          next: "",
          parents: [],
          approver: ApproverType.DepartmentSupervisor,
          departmentSupervisor: {
            type: "manual",
            departmentId: "dept_finance",
          },
        },
        {
          next: "",
          parents: [],
          approver: ApproverType.DepartmentSupervisor,
          departmentSupervisor: {
            type: "manual",
            departmentId: "dept_marketing",
          },
        },
      ],
    },
    targetPosition: Position.Top,
    sourcePosition: Position.Bottom,
    measured: { width: 594, height: 158 },
  },
  {
    id: "ParallelApproval-1762503687760",
    type: WorkflowNodeKey.ParallelApproval,
    position: { x: 887.5, y: 736 },
    data: {
      next: "",
      parents: [],
      logic: "and",
      selectedApprovalIndex: 1,
      approvals: [
        {
          approver: ApproverType.DepartmentSupervisor,
          departmentSupervisor: {
            type: "manual",
            departmentId: "dept_finance",
          },
          next: "",
          parents: [],
        },
        {
          approver: ApproverType.DepartmentSupervisor,
          departmentSupervisor: {
            type: "manual",
            departmentId: "dept_marketing",
          },
          next: "",
          parents: [],
        },
      ],
    },
    targetPosition: Position.Top,
    sourcePosition: Position.Bottom,
    measured: { width: 594, height: 158 },
  },
  {
    id: "Approval-1762503690851",
    type: WorkflowNodeKey.Approval,
    position: { x: 243.5, y: 994 },
    data: {
      approver: ApproverType.ApplicantReportLine,
      specificUser: { type: "manual", userId: "" },
      approveMethod: { method: "to_job_grade", jobGrade: 80 },
      advancedSetting: "",
      shouldSkip: true,
      next: "",
      parents: [],
    },
    targetPosition: Position.Top,
    sourcePosition: Position.Bottom,
    measured: { width: 280, height: 84 },
  },
  {
    id: "Approval-1762503694027",
    type: WorkflowNodeKey.Approval,
    position: { x: 887.5, y: 994 },
    data: {
      approver: ApproverType.ApplicantReportLine,
      departmentSupervisor: { type: "manual", departmentId: "" },
      approveMethod: {
        method: "to_job_grade",
        jobGrade: 110,
      },
      advancedSetting: "",
      shouldSkip: true,
      next: "",
      parents: [],
    },
    targetPosition: Position.Top,
    sourcePosition: Position.Bottom,
    measured: { width: 280, height: 84 },
    selected: true,
  },
  {
    id: "ParallelApproval-1762503704962",
    type: WorkflowNodeKey.ParallelApproval,
    position: { x: -400.5, y: 736 },
    data: {
      logic: "and",
      selectedApprovalIndex: 1,
      approvals: [
        {
          approver: ApproverType.DepartmentSupervisor,
          departmentSupervisor: {
            type: "manual",
            departmentId: "dept_finance",
          },
          next: "",
          parents: [],
        },
        {
          approver: ApproverType.DepartmentSupervisor,
          departmentSupervisor: {
            type: "manual",
            departmentId: "dept_marketing",
          },
          next: "",
          parents: [],
        },
      ],
      next: "",
      parents: [],
    },
    targetPosition: Position.Top,
    sourcePosition: Position.Bottom,
    measured: { width: 594, height: 158 },
  },
];

const layoutedEdges: FlowDefinition["edges"] = [
  {
    id: "form-node-to-Approval-1762503660232",
    source: "form-node",
    target: "Approval-1762503660232",
    sourceHandle: "bottom",
    targetHandle: "top",
  },
  {
    id: "Approval-1762503660232-to-Condition-1762503668062",
    source: "Approval-1762503660232",
    target: "Condition-1762503668062",
    sourceHandle: "bottom",
    targetHandle: "top",
  },
  {
    id: "Condition-1762503668062-to-Placeholder-1762503668156",
    source: "Condition-1762503668062",
    target: "Placeholder-1762503668156",
    sourceHandle: "bottom",
    targetHandle: "top",
    data: { label: "FallBack" },
  },
  {
    id: "Placeholder-1762503668156-to-end-node",
    source: "Placeholder-1762503668156",
    target: "end-node",
    sourceHandle: "bottom",
    targetHandle: "top",
  },
  {
    id: "Condition-1762503668062-to-Placeholder-1762503669515",
    source: "Condition-1762503668062",
    target: "Placeholder-1762503669515",
    type: "Label",
    data: { label: "Condition:", index: 1 },
    sourceHandle: "bottom",
    targetHandle: "top",
  },
  {
    id: "Condition-1762503668062-to-Placeholder-1762503670556",
    source: "Condition-1762503668062",
    target: "Placeholder-1762503670556",
    type: "Label",
    data: { label: "Condition:", index: 2 },
    sourceHandle: "bottom",
    targetHandle: "top",
  },
  {
    id: "Condition-1762503668062-to-Placeholder-1762503671456",
    source: "Condition-1762503668062",
    target: "Placeholder-1762503671456",
    type: "Label",
    data: { label: "Condition:", index: 3 },
    sourceHandle: "bottom",
    targetHandle: "top",
  },
  {
    id: "Placeholder-1762503670556-to-ParallelApproval-1762503685183",
    source: "Placeholder-1762503670556",
    target: "ParallelApproval-1762503685183",
    type: "Label",
    sourceHandle: "bottom",
    targetHandle: "top",
  },
  {
    id: "Placeholder-1762503671456-to-ParallelApproval-1762503687760",
    source: "Placeholder-1762503671456",
    target: "ParallelApproval-1762503687760",
    type: "Label",
    sourceHandle: "bottom",
    targetHandle: "top",
  },
  {
    id: "ParallelApproval-1762503685183-to-Approval-1762503690851",
    source: "ParallelApproval-1762503685183",
    target: "Approval-1762503690851",
    type: "Label",
    sourceHandle: "bottom",
    targetHandle: "top",
  },
  {
    id: "Approval-1762503690851-to-end-node",
    source: "Approval-1762503690851",
    target: "end-node",
    type: "Label",
    sourceHandle: "bottom",
    targetHandle: "top",
  },
  {
    id: "ParallelApproval-1762503687760-to-Approval-1762503694027",
    source: "ParallelApproval-1762503687760",
    target: "Approval-1762503694027",
    type: "Label",
    sourceHandle: "bottom",
    targetHandle: "top",
  },
  {
    id: "Approval-1762503694027-to-end-node",
    source: "Approval-1762503694027",
    target: "end-node",
    type: "Label",
    sourceHandle: "bottom",
    targetHandle: "top",
  },
  {
    id: "Placeholder-1762503669515-to-ParallelApproval-1762503704962",
    source: "Placeholder-1762503669515",
    target: "ParallelApproval-1762503704962",
    type: "Label",
    sourceHandle: "bottom",
    targetHandle: "top",
  },
  {
    id: "ParallelApproval-1762503704962-to-end-node",
    source: "ParallelApproval-1762503704962",
    target: "end-node",
    type: "Label",
    sourceHandle: "bottom",
    targetHandle: "top",
  },
];

export const EXPENSE_FLOW: FlowDefinition = {
  id: "expense-flow",
  revisionId: "",
  name: "費用申請審核流程",
  description: `⭐以簽核職級為例 (子公司費用申請):
  1. 所有費用，至少核一階主管
  2. 費用< 10萬，核至職級60
  3. 費用於職級60 核完後，會簽至總部人員 會簽完成，
  4. 費用>= 10萬，且< 50萬，依申請人reporting line 往上簽核，核至職級80 (須排除已經簽核過的直
  5. 主管職級50 & 60) 費用>= 50萬，核至主管職級110`,
  nodes: layoutedNodes,
  edges: layoutedEdges,
  createdAt: "",
  updatedAt: "",
  version: 0,
  publishStatus: FormStatus.Published,
  tags: [
    {
      id: "dept_finance",
      name: "Finance",
      description: "Manages company finances, budgeting, and expense claims.",
      color: "#F27430",
      abbrev: "Finance",
      createdAt: "",
      createdBy: "",
    },
  ],
};
